import { forwardRef, useEffect, useRef } from "react";

const FrontContactTextarea = forwardRef(function Textarea(
    {
        type = "text",
        className = "",
        isFocused = false,
        margin = true,
        rowsAmount = "4",
        ...props
    },
    ref
) {
    const input = ref ? ref : useRef();

    useEffect(() => {
        if (isFocused) {
            input.current.focus();
        }
    }, []);

    return (
        <textarea
            {...props}
            type={type}
            rows={rowsAmount}
            className={
                `min-h-c110 border-darker-blue transition-shadow ease-in-out duration-300 bg-EBEBEB focus:ring-offset-light-blue focus:ring-offset-2 focus:ring-0 px-3 py-c2 text-14 text-light-blue font-medium italic border-0 w-full ${
                    margin && "mb-5"
                } ` + className
            }
            ref={input}
        />
    );
});

export default FrontContactTextarea;
